import { loginByFbApi } from 'api/auth'
import errorHandler from 'utils/errorHandler'
import handleBindingPhone from 'utils/auth/handleBindingPhone'
import { login, setTrustDevice } from 'redux/auth/slice'
import { memberInfoApi } from 'api/member'
import handleNeedBindTrustDevice from 'utils/auth/handleNeedBindTrustDevice'
import checkIsCoolingPeriod from 'utils/checkIsCoolingPeriod'

export default accessToken => async (dispatch) => {
  try {
    await dispatch(setTrustDevice({ loginType: 'FB' }))
    const result = await loginByFbApi(accessToken)
    if (result && result.needBindTrustDevice) {
      await handleNeedBindTrustDevice(result)
    } else {
      await dispatch(login())
      const memberInfoData = await memberInfoApi()
      await handleBindingPhone(memberInfoData, dispatch)
      checkIsCoolingPeriod(result)
    }
  } catch (error) {
    errorHandler(error)
  }
}
